import axios, { AxiosRequestConfig, isAxiosError } from 'axios';
import { useState } from 'react';

type FecthState = {
    downloadUrl: string | undefined;
    file: File | null;
    isLoading: boolean;
    error: string | null;
    handleFileChange: (files: File[]) => void;
    handleUpload: (e: React.FormEvent<HTMLFormElement>) => Promise<void>;
    handleFileRemove: () => void;
    handleResetStatus: () => void;
}

export const useFetchWithFile = (url: string, params?: Record<string, unknown>): FecthState => {
    const [fetchUrl] = useState<string>(url);
    const [file, setFile] = useState<File | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [downloadUrl, setDownloadUrl] = useState<string | undefined>(undefined);

    const handleUpload = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const fetchData = async () => {
            setIsLoading(true);
            setError(null);

            const config: AxiosRequestConfig = {
                maxBodyLength: Infinity,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer 6873b7bdb607654646610c860ae94128'
                },
                responseType: 'blob'
            };

            if(!file){
                setError('Erro: Nenhum arquivo selecionado.');
                return
            }
            const formData: FormData = new FormData();
            formData.append('file', file);
            if(params){
                formData.append('params', JSON.stringify(params));
            }

            try {
                const response = await axios.post<ArrayBuffer>(fetchUrl, formData, config);
                const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
        
                const url = window.URL.createObjectURL(blob);
                console.log(url);
                
                setDownloadUrl(url);                
            } catch (error) {
                const message = isAxiosError(error) && error.response ? 
                    `${error.response.status} - ${error.response.statusText}` :
                    `Ocorreu um erro inesperado: ${(error as Error).message}`;

                setError(message);
            }finally{
                setIsLoading(false);
            }
        }

        fetchData();
    };

    const handleFileChange = async (files: File[]) => {
        if(files.length > 0){
            setFile(files[0]);
        }
    }

    const handleFileRemove = () => {
        setFile(null);
    }

    const handleResetStatus = () => {
        setFile(null);
        setDownloadUrl(undefined);
        setIsLoading(false);
        setError(null);
    }

    return { 
        file, 
        downloadUrl, 
        isLoading, 
        error, 
        handleUpload, 
        handleFileChange, 
        handleFileRemove, 
        handleResetStatus};
}